import { render } from "./BaseSlider.vue?vue&type=template&id=27d9b69a&ts=true"
import script from "./BaseSlider.vue?vue&type=script&lang=ts"
export * from "./BaseSlider.vue?vue&type=script&lang=ts"

import "./BaseSlider.vue?vue&type=style&index=0&id=27d9b69a&lang=scss"
import "./BaseSlider.vue?vue&type=style&index=1&id=27d9b69a&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__